<template>
    <div class="newPublish">
        <div class="title">
            最新发布
        </div>
        <div class="content">
            <ul>
                <li v-for="(item, index) in dataList" :class="dataListIndex===index ? 'on': ''" @click="detail(item)">
                    <a>
                        <div class="wordTitle" v-if="item.typeTag===0" :title="item.title"><p>{{item.title}}</p></div>
                        <div class="picTitle" v-if="item.typeTag===1">
                            <div class="picBG">
                                <div class="picBG-only-img"><img class="only-img" :src="item.imgUrl" alt=""></div>
                            </div>
                            <p :title="item.title">{{item.title}}</p>
                        </div>
                        <div class="picTitle" v-if="item.typeTag===2">
                            <div class="picBG videoPic">
                                <div class="videoPic-video-detail"><video width=100% height=100% v-if="item.XQ_VideoUrl" :src="item.XQ_VideoUrl"></video></div>
                                <div class="videoPic-video-icon"><img src="../../assets/images/springFrame/video.png" alt="" /></div>
                            </div>
                            <p :title="item.title">{{item.title}}</p>
                        </div>
                        <div class="picTitle" v-if="item.typeTag==3">
                            <div class="picBG videoPic">
                                <div class="videoPic-video-detail"><video width=100% height=100% v-if="item.imgUrl" :poster="item.imgUrl"></video></div>
                                <div class="videoPic-video-icon" v-if="item.imgUrl"><img src="../../assets/images/springFrame/video.png" alt="" /></div>
                            </div>
                            <p :title="item.title">{{item.title}}</p>
                        </div>
                        <div class="info">
                            <div class="resource">
                                <span v-for="(item1,index1) in item.resource" :class="item1"></span>
                            </div>
                            <span>{{item.media_resource}}</span>
                            <div class="dateInfo">{{item.XQDOCPUBTIME}}</div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        <pub-detail-manuscript v-model="showMore" @showManuJZ="showManuJZ" :showObj="showObj" :isShowBig="isShowBig"></pub-detail-manuscript>
    </div>
</template>

<script>
    import PubDetailManuscript from '@/views/index/pubFolder/pubDetail.vue';

    export default {
        name: "newPublish",
        data() {
            return {
                isShowBig: false,
                showObj: {},
                showMore: false,
                dataList: [],
                headTitle: '最新发布',
                headTitleTag: 'zxfb',
                dataListIndex: 0,
                timer: null,

                imgBtnNo: false,
                imgBtnHave: false,
                imgBtnOne: false,
                datatimer: null

            }
        },
        components: { PubDetailManuscript },
        mounted() {
            this.getData();
            this.datatimer =setInterval(() => {
                this.getData();
            }, 1000*60*15);
            this.timer =setInterval(() => {
                if(this.dataListIndex <3){
                    this.dataListIndex = this.dataListIndex+1;
                } else {
                    this.dataListIndex = 0;
                }
            }, 1000*5);
        },
        // 页面销毁前
        beforeDestroy(){
            clearInterval(this.timer);
            clearInterval(this.datatimer);
        },
        methods: {
            getData(){
                this.axios.get('/bigscreen/zuixinfabu.json').then(res => {
                    
                    var data = res.data.data;
                    this.dataList = [];
                    for(var key in data){
                        this.dataList.push(data[key][0]);
                    }
                    this.dataList = this.dataList.slice(0,4);

                    // this.dataList[1].XQ_ImgUrl = [
                    //     {Url: "http://121.194.3.144/webpic/W0202206/W020220628/W020220628599220249088.jpg"},
                    //    {Url: "http://121.194.3.144/webpic/W0202206/W020220628/W020220628599221562723.jpg"},
                    //    {Url: "http://121.194.3.144/webpic/W0202206/W020220628/W020220628599223942514.jpg"},
                    //    {Url: "http://121.194.3.144/webpic/W0202206/W020220628/W020220628599229455669.jpg"},
                    // ]; 
                    // this.dataList[0].XQ_VideoUrl = 'http://121.194.3.144/masvod/public/2022/06/07/20220607_1813ce3a420_r1.mp4';
                    // this.dataList[2].XQ_VideoUrl = 'https://aweme.snssdk.com/aweme/v1/playwm/?video_id=v0200fg10000cajb97rc77u580qn4su0&ratio=720p&line=0';

                    for(var i=0;i<this.dataList.length;i++){
                        if(this.dataList[i].type == 'wx'){
                            this.dataList[i].resource = ['weChat']; 
                        }
                        if(this.dataList[i].type == 'szb'){
                            this.dataList[i].resource = ['newspaper'];
                        }
                        if(this.dataList[i].type == 'wz'){
                            this.dataList[i].resource = ['website'];
                        }
                        if(this.dataList[i].type == 'wb'){
                            this.dataList[i].resource = ['weibo'];
                        }
                        if(this.dataList[i].type == 'douyin'){
                            this.dataList[i].resource = ['douyin'];
                        }
                        if(this.dataList[i].type == 'app'){
                            this.dataList[i].resource = ['client'];
                        }
                        
                        if(this.dataList[i].type == 'douyin'){
                            this.dataList[i].typeTag = 3;
                        } else {
                            if(this.dataList[i].XQ_VideoUrl){
                                this.dataList[i].typeTag = 2;
                            } else if(this.dataList[i].imgUrl){
                                this.dataList[i].typeTag = 1;
                            } else {
                                this.dataList[i].typeTag = 0;
                            }
                        }
                        
                    }

                })
            },
            detail(item){
                
                // if(item.typeTag == 3){
                //    window.open(item.XQCONTENT);
                //    return;
                // }
                this.showMore = true;
                this.isShowBig = true;
                item.headTitle = this.headTitle;
                item.headTitleTag = this.headTitleTag;

                if(item.XQ_ImgUrl.length ==1){
                    this.imgBtnOne = true;
                    this.imgBtnNo = false;
                    this.imgBtnHave = false;
                } else {
                    this.imgBtnOne = false;
                    this.imgBtnNo = false;
                    this.imgBtnHave = true;
                }
                
                item.imgBtnNo = this.imgBtnNo;
                item.imgBtnHave = this.imgBtnHave;
                item.imgBtnOne = this.imgBtnOne;

                this.showObj = item;
            },
            showManuJZ(row) {
                this.isShowBig = row;
            }
        }
    }
</script>

<style scoped>
    .newPublish{
        color: #fff;
        width: 1480px;

    }
    .newPublish .title{
        background: url("../../assets/images/newPublish.png") center center no-repeat;
        background-size: 100% 100%;
        font-size: 42px;
        line-height: 67px;
        height: 67px;
        text-align: center;
        /*font-weight: bold;*/
        font-family: hyk1gj;
    }
    .content{
        margin-top: 36px;
    }
    .content a{
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
    }
    .content ul{
        display: flex;
        justify-content: space-between;
    }
    .content ul li{
        background: url("../../assets/images/newPublishBG.png")center center no-repeat;
        background-size: 100% 100%;
        width: 358px;
        height: 427px;
        padding: 32px 26px;
        box-sizing: border-box;
    }
    .content ul li.on{
        background: url("../../assets/images/newPublishBGOn.png")center center no-repeat;
        background-size: 100% 100%;
    }
    .content ul li.on p{
        color: #eacb42;
    }
    .content ul li a{
        color: #fff;
    }
    .wordTitle{
        font-size: 30px;
        line-height: 54px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
    }
    .picTitle p{
        font-size: 30px;
        line-height: 54px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .picTitle .picBG{
        background: #000;
        text-align: center;
        overflow: hidden;
    }
    .picTitle .picBG .picBG-only-img {
        height: 200px;
        width: 310px;
        position: relative;
    }
    .picTitle .picBG .picBG-only-img .only-img {
        max-width: 100%;
        max-height: 100%;
        margin: auto;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        position: absolute;
    }
    .picTitle .videoPic {
        max-height: 200px;
        max-width: 310px;
        background-color: #000;
    }
    .picTitle .videoPic .videoPic-video-detail {
        float:left;
        width: 310px;
        height: 200px;
    }
    .picTitle .videoPic .videoPic-video-icon {
        position:absolute;
        margin-left: 110px;
        margin-top: 45px;
    }
    .picTitle .videoPic .videoPic-video-icon img {
        width: 90px;
    }
    .info, .dateInfo{
        color: #88b5fb;
        font-size: 27px;
    }
    .info img{
        vertical-align: bottom;
        margin-right: 15px;
    }
    .dateInfo{
        margin-top: 24px;
    }

    .info .resource{
        display: flex;
        float: left;
        margin-right: 6px;
        margin-top: 2px;
    }
    .info .weChat{
        background: url("../../assets/images/icon_wechat.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .info .newspaper{
        background: url("../../assets/images/icon_paper.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .info .website{
        background: url("../../assets/images/icon_website.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .info .weibo{
        background: url("../../assets/images/icon_weibo.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .info .douyin{
        background: url("../../assets/images/icon_douyin.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .info .client{
        background: url("../../assets/images/icon_client.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
</style>
